// extracted by mini-css-extract-plugin
export default {"container":"uTeKmi","details":"Y5GjzR","opaque":"uglrJD"};